<template>
    <div class="rate-checks">
        <h2>
            Ad Product Verification
            <info-tooltip
                text="This is a list of products included with the dimensions of this ad set. The Status shows whether rates are present for the specified product."></info-tooltip>
        </h2>
        <div class="preview-rate-check-col flex flex-col">
            <component :is="adProductVerificationHeader"></component>
            <div v-for="rateCheck in sortedRates" :key="rateCheck.id" class="flex rate-row">
                <div class="flex items-center justify-end flex-2 text-right p-md">
                    {{ rateCheck.product_type }}
                </div>
                <div class="flex items-center justify-end flex-2 text-right p-md">
                    {{ rateCheck.product_name }}
                </div>
                <div v-if="hasRate(rateCheck)"
                     class="flex items-center justify-end flex-2 text-right p-md rate-checks-found">
                        {{ getRate(rateCheck) }}%
                </div>
                <div v-else class="flex items-center justify-end flex-2 text-right p-md rate rate-checks-not-found">
                    <i class="material-icons">warning</i>
                    Not Found
                </div>
                <div class="flex items-center justify-end flex-2 text-right p-md">
                    <state-list
                        :stateAbbreviations="rateCheck.locations">
                    </state-list>
                </div>
                <div class="flex items-center justify-end flex-2 text-right p-md">
                    <span>
                        <span v-if="hasRate(rateCheck) && (rateCheck.deposit_min == 0 || rateCheck.deposit_min)">
                            ${{ rateCheck.deposit_min | currency | trimDecimals }}
                        </span>
                    </span>
                </div>
                <div class="flex items-center justify-end flex-1 text-right p-md">
                    {{ rateCheck.rate_type }}
                </div>
            </div>
            <div v-if="rates.length == 0 && !loading" v-cloak>
                <div class="max-width text-center">
                    There are no rates to display
                </div>
            </div>
            <div v-show="loading">
                <div class="max-width text-center">
                    <i class="fa fa-spinner fa-spin inner-loading"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .rate-row {
        border-bottom: solid 1px #d1d1d1;
        color: #202020;

        &:first-of-type {
            font-size: 14px;
            font-weight: bold;
            text-transform: uppercase;
            letter-spacing: 0.3px;
            color: #3f4148;
            border-bottom: solid 1px #000;
        }
    }

    .rate-checks-found {
        color: #20cb7e !important;
    }

    .rate-checks-not-found {
        color: #ff8d00 !important;
        i {
            font-size: 26px;
            margin-right: 2px;
        }
    }
</style>

<script>
  import _ from 'lodash';
  import AdProductHeadingDeposits from './ad-product-heading.vue';
  import StateList from '../../utils/state-list.vue';

  export default {
    name: 'AdSetRateChecks',
    props: ['campaign', 'adSetId', 'allLocations', 'isNationalLoanPurpose'],
    data () {
      return {
        rates: [],
        loading: true
      };
    },
    created () {
      this.getRates();
    },
    computed: {
      sortedRates () {
        return _.orderBy(this.rates, [
          (rate) => rate.locations.length,
          'terms_cd_months',
          'product_name'
        ], ['desc', 'asc', 'asc'])
        .filter((rate) => {
            if (this.isNationalLoanPurpose) {
                return rate.rate_type === 'National';
            } else {
                return rate.rate_type === 'Local';
            }
        });
      },
      adProductVerificationHeader () {
        return 'ad-product-heading-deposits';
      }
    },
    methods: {
      hasRate (rateCheck) {
        return rateCheck.locations.length && this.getRate(rateCheck);
      },

      getRate (rateCheck) {
        return rateCheck.yield;
      },

      stateAbbreviations (locations) {
        return _.map(locations, 'id').join(' | ');
      },

      formatLoanRanges: function (rate) {
        if (rate.loan_min > 0) {
          var loanMin = Number(rate.loan_min).toLocaleString(),
          loanMax = Number(rate.loan_max).toLocaleString();

          return '$' + loanMin + ' - $' + loanMax;
        }

        return 'None';
      },
      getRates () {
        const vm = this;
        const url = `${window.Portal.baseUrl}/api/campaign/${this.campaign.id}/adset/${this.adSetId}/rates`;

        axios.get(url)
        .then(function (response) {
          vm.rates = response.data.rateData;
          this.showStatesBitMap = new Array(vm.rates.length).fill(false);
          vm.loading = false;
        })
        .catch(function () {
          vm.loading = false;
        });
      }
    },

    components: {
      AdProductHeadingDeposits,
      StateList
    }
  };
</script>
